import {
  FormEvent,
  FunctionComponent,
  InputHTMLAttributes,
  RefObject,
} from 'react';
import styled from 'styled-components';

import HeaderSearch from '@/components/atom/icon/HeaderSearch';
import theme from '@/styles/theme';

export interface SearchInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  onSubmit: () => void;
  searchInputRef?: RefObject<HTMLInputElement>;
}

const SearchInput: FunctionComponent<SearchInputProps> = ({
  onSubmit,
  searchInputRef,
  ...props
}) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    searchInputRef?.current?.blur();
    onSubmit();
  };

  return (
    <SearchInputWrapper>
      <form onSubmit={handleSubmit}>
        <SearchInputStyled tabIndex={0} {...props} ref={searchInputRef} />
        <SearchIconWrapper type="submit">
          <HeaderSearch size={16} fill={theme.color.gray400} />
        </SearchIconWrapper>
      </form>
    </SearchInputWrapper>
  );
};

export default SearchInput;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-left: 16px;
`;

export const SearchInputStyled = styled.input`
  ${({ theme }) => `
    ${theme.typography.UI18M};
    background: ${theme.color.gray40};
    color: ${theme.color.gray700};
    &::placeholder {
      color: ${theme.color.gray300};
    }
  `};

  border: none;
  height: 48px;
  width: 100%;
  padding: 0 48px 0 16px;
  border-radius: 8px;

  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    font-size: 16px;
  }
`;

export const SearchIconWrapper = styled.button`
  position: absolute;
  right: 12px;
  border: none;
  top: 50%;
  transform: translate(0, -50%);
  padding: 6px;
  background: none;
`;
